import { Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { CellClassParams, CellStyle, ColDef, SelectionChangedEvent, ValueFormatterParams } from 'ag-grid-enterprise';
import { debounceTime } from 'rxjs/operators';
import { UserService } from 'src/app/services/user.service';
import { HyperlinkCellRenderer } from 'src/app/shared/cancom-table/cell-renderer/hyperlink-cell-renderer.component';
import { SharedComponentsModule } from 'src/app/shared/shared-components.module';
import { NotificationService } from '../services/notification.service';

@Component({
	selector: 'app-list-notifications',
	templateUrl: './list-notifications.component.html',
	styleUrls: ['./list-notifications.component.scss'],
	imports: [
		SharedComponentsModule,
		MatFormFieldModule,
		MatIconModule,
		FormsModule,
		ReactiveFormsModule,
		MatButtonModule,
		MatInputModule,
		FlexLayoutModule,
	],
})
export class NotificationComponent implements OnInit {
	public error: string[] = [];
	public loading: boolean = true;

	public columnsDef: ColDef[] = [
		{
			field: 'id',
			headerName: 'ID',
			cellRenderer: HyperlinkCellRenderer,
			headerCheckboxSelection: true,
			headerCheckboxSelectionFilteredOnly: true,
			checkboxSelection: true,
		},
		{
			field: 'noteType',
			headerName: 'Type',
			cellStyle: (cellClassParams: CellClassParams): CellStyle => {
				let color = 'unset';

				if (cellClassParams.value == 'INFO') {
					color = '#d9edf7';
				} else if (cellClassParams.value == 'WARNING') {
					color = '#feefb3';
				} else if (cellClassParams.value == 'ERROR') {
					color = '#ffbaba';
				}

				return {
					'background-color': color,
				};
			},
			maxWidth: 200,
		},
		{
			field: 'tenant',
			headerName: 'Tenant',
		},
		{
			field: 'title',
			headerName: 'Title',
			flex: 2,
		},
		{
			field: 'message',
			headerName: 'Message',
			flex: 2,
		},
		{
			field: 'service',
			headerName: 'Service',
		},
		{
			field: 'createdAt',
			headerName: 'Created At',
			valueFormatter: (params: ValueFormatterParams) => {
				return new Date(+params.value * 1000).toLocaleString('de-DE');
			},
			maxWidth: 200,
			sort: 'desc',
		},
		{
			field: 'expireAt',
			headerName: 'Expires At',
			valueFormatter: (params: ValueFormatterParams) => {
				return new Date(+params.value * 1000).toLocaleString('de-DE');
			},
			maxWidth: 200,
		},
		{
			field: 'requiresAction',
			headerName: 'Requires Action',
			maxWidth: 200,
		},
	];
	public selectedRows: any[] = [];
	public rows?: any[] = undefined;
	public isAdmin: boolean = false;

	public notificationSearch: UntypedFormControl = new UntypedFormControl('');
	public notificationSearchValue: string = '';

	constructor(
		private notificationService: NotificationService,
		private userService: UserService
	) {}

	async ngOnInit() {
		const permissions = (await this.userService.getPermissions('notification-service')) || {};
		this.isAdmin = 'administrator' in permissions;

		this.notificationSearch.valueChanges.pipe(debounceTime(500)).subscribe((value) => {
			this.selectedRows = [];
			this.notificationSearchValue = value;
		});

		this.loadNotifications();
	}

	async loadNotifications() {
		this.loading = true;
		this.rows = (await this.notificationService.getNotifications(true)).map((notification) => ({
			...notification,
			id: { displayName: notification.noteId, link: notification.noteId },
		}));
		this.loading = false;
	}

	public selectionChanged(event: SelectionChangedEvent) {
		this.selectedRows = event.api.getSelectedRows();
	}

	public deleteNotifications() {
		if (confirm('Are you sure you want to delete the selected Notifications? This action is irreversible.')) {
			for (const row of this.selectedRows) {
				this.notificationService.deleteNotification(row.noteId);
			}
		}
	}
}
